import styles from "./ResultsDonut.module.css"

export default function ResultsDonut({ data, label }) {
    const total = data.reduce((sum, item) => sum + item.rawValue, 0)
    return <div className={styles.donut}>
        <svg viewBox="0 0 240 240" role="img" aria-label={`${label}: ${data.map(item => `${item.label} ${item.rawValue}`).join(", ") || "nessun risultato"}`}>
            <circle cx="120" cy="120" r="92" fill="none" stroke="rgba(var(--text-color-rgb), .06)" strokeWidth="22" />
            {data.map((item, index) => item.value > 0 && <circle key={item.id} cx="120" cy="120" r="92" fill="none" stroke={item.color} strokeWidth="22" pathLength="100" strokeDasharray={`${item.value} ${100 - item.value}`} strokeDashoffset={-data.slice(0, index).reduce((sum, entry) => sum + entry.value, 0)} transform="rotate(-90 120 120)" />)}
            <text x="120" y="117" textAnchor="middle" className={styles.value}>{total}</text>
            <text x="120" y="141" textAnchor="middle" className={styles.label}>{label}</text>
        </svg>
    </div>
}
